import {useContext, useState, useEffect} from "react";
import ThemeContext from "../context/ThemeContext";
import LanguageContext from "../context/LanguageContext";
import Login from "./Login";
import { Link, useNavigate } from "react-router-dom";

export default function Header(){
    const {theme, toggleTheme} = useContext(ThemeContext);
    const {language, toggleLanguage} = useContext(LanguageContext);
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    
    const handleArchiveMapClick = () => {
        navigate('/archive-map');
    };
    
    return(
        <div className="header-container">
            <Login />
            <header className={"header"} style={{
                backgroundColor: "black", 
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "1rem"
            }}>
                {/* Left logo - smaller on mobile but always visible */}
                <div className="header__logo header__logo--left">
                    <img 
                        src="/images/left_logo.png" 
                        alt="Left Logo" 
                        style={{
                            maxHeight: isMobile ? "50px" : "100px", 
                            margin: isMobile ? "3px" : "10px"
                        }} 
                    />
                </div>
                
                {/* Center logo - always show, smaller on mobile */}
                <div className="header__logo header__logo--center">
                    <img 
                        src="/images/center_logo.png" 
                        alt="Center Logo" 
                        style={{
                            maxHeight: isMobile ? "60px" : "100px", 
                            margin: isMobile ? "5px" : "10px"
                        }} 
                    />
                </div>
                
                {/* Right logo - smaller on mobile but always visible */}
                <div className="header__logo header__logo--right">
                    <img 
                        src="/images/right_logo.png" 
                        alt="Right Logo" 
                        style={{
                            maxHeight: isMobile ? "50px" : "100px", 
                            margin: isMobile ? "3px" : "10px"
                        }} 
                    />
                </div>
                
                {/* User authentication section - only show welcome text */}
                <div style={{
                    position: "absolute", 
                    top: "10px", 
                    right: "10px",
                    display: "flex",
                    gap: "15px",
                    alignItems: "center"
                }}>

                </div>
            </header>
            
            {/* Second row for toggles and navigation */}
            <div className="header-bottom-row">
                <div className="header-bottom-left">
                    <button className="archive-map-button" onClick={handleArchiveMapClick}>Archive Map</button>
                </div>

                <div className="header-bottom-center">
                    <Link to="/" className="home-button">Home</Link>
                </div>
                
                <div className="header-bottom-right">
                    {/* Language toggle switch */}
                    <div className="language-switch-wrapper header-language-toggle">
                        <span className="language-switch-label">English</span>
                        <label className="language-switch">
                            <input 
                                type="checkbox" 
                                checked={language === 'persian'} 
                                onChange={toggleLanguage}
                            />
                            <span className="slider round"></span>
                        </label>
                        <span className="language-switch-label">فارسی</span>
                    </div>
                    
                    {/* Theme toggle switch */}
                    <div className="theme-switch-wrapper header-theme-toggle">
                        <span className="theme-switch-label">Light</span>
                        <label className="theme-switch">
                            <input 
                                type="checkbox" 
                                checked={theme === 'dark'} 
                                onChange={toggleTheme}
                            />
                            <span className="slider round"></span>
                        </label>
                        <span className="theme-switch-label">Dark</span>
                    </div>
                </div>
            </div>
        </div>
    )
}